/* unplugin-vue-components disabled */import script from "./NavMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./NavMenu.vue?vue&type=script&setup=true&lang=js"

import "./NavMenu.vue?vue&type=style&index=0&id=3afaf7bf&lang=scss"

const __exports__ = script;

export default __exports__